'use client';

import { Text } from '@actr/ui/src/components/_atoms/text';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import { canUseDom } from '@actr/utilities/src/dom';
import ApplicationBanner from '@actr/widgets/src/components/seo/application-banner';
import React, { memo } from 'react';

import { SideBarItem } from '@/services/models/nav-bar';

import * as Styled from './style.css';

export type SideBarProps = {
  title?: string;
  items: SideBarItem[];
  isAppBannerEnable?: boolean;
  isHideNavBarOnMobile?: boolean;
}

const SideNavBar: React.FC<SideBarProps> = ({
  items,
  title = 'Быстрая навигация',
  isAppBannerEnable = false,
  isHideNavBarOnMobile = false
}) => {
  const handleClick = (id: string, ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (canUseDom) {
      ev.preventDefault();
      document.getElementById(id)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className={Styled.SidebarContent}>
      <ContentBlock
        className={Styled.SideNavBarWrapper({ isHideNavBarOnMobile })}
        tagProps={{ itemScope: true, itemType: 'https://schema.org/ItemList' }}>
        <meta itemProp="numberOfItems" content={items.length.toString()} />
        <Text
          tagName="h3"
          font="title.x2l"
          tagProps={{
            itemProp: 'name',
            content: title
          }}>
          {title}
        </Text>
        <div className={Styled.ContentWrapper}>
          {items.map((item, index) => (
            <a
              itemProp="itemListElement"
              itemType="https://schema.org/ListItem"
              itemScope
              className={Styled.Link}
              key={item.id}
              href={`#${item.id}`}
              onClick={ev => handleClick(item.id, ev)}>
              <meta itemProp="position" content={(index + 1).toString()} />
              <div itemProp="name">
                {item.name}
              </div>
            </a>
          ))}
        </div>
      </ContentBlock>
      { isAppBannerEnable && (
        <div className={Styled.AppBannerWrapper}>
          <ApplicationBanner isSideBarCompact={true} />
        </div>
      ) }
    </div>
  );
};

export default memo(SideNavBar);
